// Definitions

(function() {

  if (typeof window.SITE === "undefined") {
    window.SITE = {};
  }

  SITE.enableMasonry = function() {
      $('.news-listing').masonry({
      // options...
      columnWidth: '.grid-sizer',
      itemSelector: '.news-listing__listing',
      horizontalOrder: true,
      percentPosition: true
    });
  }

  SITE.setEqualLiHeights = function () {
    const listItems = document.querySelectorAll('ul.news-listing li a'); 

    let maxHeight = 0;

    // Reset height to get natural heights first
    listItems.forEach(li => li.style.height = 'auto');

    listItems.forEach(li => {
      if (li.offsetHeight > maxHeight) {
        maxHeight = li.offsetHeight + 50;
      }
    });

    listItems.forEach(li => li.style.height = `${maxHeight}px`);
  }

})();


// Invocations

$(function () {


  // SITE.enableMasonry();
  //SITE.setEqualLiHeights();
  window.addEventListener('resize', SITE.setEqualLiHeights);


});

$(window).on('load', function () {
  SITE.setEqualLiHeights();
});
